import React from "react";
import {

  Route,

  Redirect,

} from "react-router-dom";

import loginAPI from "../services/loginAPI";

const PrivateRouteLayout = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      let authenticated = loginAPI.isAuthenticated();
      if (authenticated === true) return <Component {...props} />;
      else return <Redirect to="/login" />;
    }}
  />
);

export default PrivateRouteLayout;
